import { render, staticRenderFns } from "./InputConfigForm.vue?vue&type=template&id=6764ba43&scoped=true&"
import script from "./InputConfigForm.vue?vue&type=script&lang=js&"
export * from "./InputConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6764ba43",
  null
  
)

export default component.exports